import { getCountryFromSideFilters, getProductGroupFromSideFilters } from '@utils/FilterUtils';
import { Option, PageName, PageType, SubSection } from '@utils/pageConfig/Types';
import { concatenateSelectedFeatureName, doAmplitudeAnalyticsTracking } from '../PageAnalytics';
import { AnalyticTrackingBasePropertiesObj, TrackingGeneralProp } from './AnalyticTrackingBasePropertiesObj';
//Example of tracking for - Page View
/**
 analytics.track("Page Viewed", { Â
 "access": "Retail Insights",
 "locationId": "Germany"
 "pageName": "Retailer Overview",
 "productGroup": "PTV" //if single select or "{PTV, Smartphones}"
 "retailerDataFor": "NameOfRetailer",Â
 "section": "Retail Intelligence",
 "subsection": "Retailer Overview"
 })
 **/

export const PAGE_VIEW_TRACKING_TITLE = 'Page Viewed';

//Extend base properties
export interface PageViewedTracking extends AnalyticTrackingBasePropertiesObj {}

export interface PageViewTrackingFunctionParam {
  eventTitle: string;
  sideFilters: any;
  retailerClientState: any;
  track: (event: string, properties?: Object) => void;
  pageType: PageType;
  pageName: PageName;
  access: Object;
  subSection?: SubSection;
  //This param is added to avoid the issue of locationId being undefined due to race condition of sideFilters not being loaded yet
  //Can be removed once the issue is fixed
  initialLocationId?: Option[];
}

export const pageViewTrackingFunction = (param: PageViewTrackingFunctionParam) => {
  const {
    pageName,
    sideFilters,
    retailerClientState,
    track,
    eventTitle,
    pageType,
    access,
    subSection,
    initialLocationId,
  } = param;

  const selectedSideFilter = sideFilters[pageType];

  const appliedProductGroup = getProductGroupFromSideFilters(selectedSideFilter);
  const appliedFiltersCountry = getCountryFromSideFilters(selectedSideFilter);

  const pageViewProperties: PageViewedTracking = {
    access: access,
    locationId: appliedFiltersCountry?.options.map((options) => options.label)
      ? appliedFiltersCountry?.options.map((options) => options.label)
      : initialLocationId?.map((options) => options.label),
    itemGroup: concatenateSelectedFeatureName(appliedProductGroup),
    pageName: pageName,
    retailerDataFor: retailerClientState.clientName,
    section: TrackingGeneralProp.SECTION_TRACKING_PROP,
    subsection: subSection ?? pageName,
  };

  doAmplitudeAnalyticsTracking(eventTitle, track, pageViewProperties);
};
